import React, { useState, useEffect } from 'react';
import { FormInstance } from 'antd/es/form';
import { Form, InputNumber } from 'antd';
import styled from 'styled-components';
import { Colors, LightGrayColor, device } from 'GlobalStyles';

const InterviewTypesProportionInput = ({ fieldName, form }: { fieldName?: number; form?: FormInstance }) => {
  const [fitProportion, setFitProportion] = useState<number>();

  useEffect(() => {
    if (fitProportion !== undefined && fitProportion >= 0 && fitProportion <= 100) {
      if (form && fieldName !== undefined) {
        const { interview_review } = form.getFieldsValue(); //Form.List value 값에 접근 => 배열 형태
        Object.assign(interview_review[fieldName], { case_importance: 100 - fitProportion }); // 출처 객체(두번째 인자)들의 속성을 복사해 대상 객체(첫번째 인자)에 붙여넣음
        form.setFieldsValue({ interview_review }); //interview_review의 해당 인덱스(fieldName)는 대상 객체가 붙여넣어진 출처 객체로 바뀐 형태가 되며, 이 값을 setFieldsValue
      }
    }
  }, [fitProportion]);

  return (
    <InterviewTypesProportionInputWrapper>
      <StyledInterviewTypeContainer>
        <StyledInterviewTypeName>Fit</StyledInterviewTypeName>
        <StyledProportionInput>
          <Form.Item
            className='form-item-fit-content'
            name={fieldName !== undefined ? [fieldName, 'fit_importance'] : 'fit_importance'} //fieldName이 0일수도 있기 때문에
            rules={[
              { required: true },
              { type: 'number', min: 0, max: 100, message: '0이상 100이하의 정수' },
            ]}
          >
            <InputNumber placeholder='00' value={fitProportion} onChange={setFitProportion} />
          </Form.Item>
          <span style={{ padding: '0 5px', color: Colors.grey5 }}>%</span>
        </StyledProportionInput>
      </StyledInterviewTypeContainer>
      <StyledInterviewTypeContainer>
        <StyledInterviewTypeName>Case</StyledInterviewTypeName>
        <StyledProportionInput className='case-type-input'>
          <Form.Item
            className='form-item-fit-content'
            name={fieldName !== undefined ? [fieldName, 'case_importance'] : 'case_importance'} //fieldName이 0일수도 있기 때문에
          >
            <InputNumber readOnly={true} placeholder='00' />
          </Form.Item>
          <span style={{ padding: '0 5px', color: Colors.grey5 }}>%</span>
        </StyledProportionInput>
      </StyledInterviewTypeContainer>
    </InterviewTypesProportionInputWrapper>
  );
};

export default InterviewTypesProportionInput;

const InterviewTypesProportionInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2px;
  margin-bottom: 20px;
  & .ant-form-item {
    margin: 0;
  }
  & .ant-input-number-input {
    text-align: right;
  }
  @media screen and ${device.sm} {
    flex-direction: column;
  }
`;

const StyledInterviewTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 45%;
  @media screen and ${device.sm} {
    width: 100%;
  }
  &:not(:first-child) {
    margin-top: 10px;
  }
`;

const StyledInterviewTypeName = styled.div`
  font-weight: 900;
  font-size: 16px;
`;

const StyledProportionInput = styled.div`
  display: flex;
  align-items: center;
  background: ${LightGrayColor};
  border-radius: 8px;
  &.case-type-input input {
    cursor: default; //케이스 유형 비중 입력 input은 커서가 text가 아닌 default로 나오도록
  }
`;
